
import Group from 'vux/src/components/group/index.vue'
import Cell from 'vux/src/components/cell/index.vue'
import CellBox from 'vux/src/components/cell-box/index.vue'
import Badge from 'vux/src/components/badge/index.vue'

import ServerResponse from 'vue-django/src/mixins/server_response'
import Qs from 'qs'
import {formatTime} from 'vue-django/src/utils/filters'
export default{
mixins: [ServerResponse],
props: {
queries: {type: Object, default: {}},
autoLoad: {type: Boolean, default: true}
},
data () {
return {
messages: []
}
},
components: {Group, Cell, CellBox, Badge},
created () {
this.autoLoad && this.load()
},
methods: {
load () {
return this.$http.get(`/message/message/current/?${Qs.stringify(this.queries)}`).then(({data}) => {
this.messages = data.results.map(m => {
let title = m.is_active ? m.title : '此消息已被删除'
let senderName = m.sender_name || '系统'
let sendTime = formatTime(m.create_time)
let d = {key: m.id, title, task: m.task_object, isRead: m.is_read, senderName, sendTime}
if (m.is_read) {
d.inlineDesc = `${senderName}  ${sendTime}`
}
if (m.is_active && m.task_object) {
let t = m.task_object
let arrowDirection = t.content ? 'down' : null
let isLink = Boolean(t.link || arrowDirection)
Object.assign(d, {isLink, arrowDirection, content: t.content})
}
return d
})

this.$emit('loaded', data)
}).catch(this.onServerResponseError)
},
onTitleClick(m) {
if (m.arrowDirection === 'down') {
m.arrowDirection = 'up'
} else if (m.arrowDirection === 'up') {
m.arrowDirection = 'down'
}
if (!m.isRead) {
this.read(m).then(() => {
if (!m.task.content) {
this.goLink(m)
}
})
} else {
if (!m.task.content) {
this.goLink(m)
}
}
},
onContentClick(m) {
this.goLink(m)
},
goLink (m) {
let link = m.task.link
if (link) {
this.$emit('golink', link)
this.$router.push(link)
}
},
read (m) {
return this.$http.post(`/message/message/${m.key}/read/`).then(({data}) => {
m.isRead = true
m.inlineDesc = `${m.senderName}  ${m.sendTime}`
})
}
},
computed: {}
}



// WEBPACK FOOTER //
// ./src/views/message/message/components/List.vue